// extracted by mini-css-extract-plugin
module.exports = {"root":"Consent_root__26nZY","content":"Consent_content__2dPv_","footer":"Consent_footer__O_5aO"};